const checkDevice = () => {
  const ua = navigator.userAgent
  const isWindowsPhone = /(?:Windows Phone)/.test(ua)
  const isSymbian = /(?:SymbianOS)/.test(ua)
  const isAndroid = /(?:Android)/.test(ua)

  const isFireFox = /(?:Firefox)/.test(ua)

  const isTablet = /(?:iPad|PlayBook)/.test(ua) ||
    (isAndroid && !/(?:Mobile)/.test(ua)) ||
    (isFireFox && /(?:Tablet)/.test(ua))
  const isPhone = /(?:iPhone)/.test(ua) && !isTablet

  const isChrome = /(?:Chrome|CriOS)/.test(ua)

  const isMobile = isWindowsPhone || isSymbian || isAndroid || isPhone
  const isPc = !isMobile
  const isIphoneXSeries = isMobile &&
    /iphone/gi.test(ua) && window.screen.height >= 812

  return {
    isMobile,
    isPc,
    isPhone,
    isWindowsPhone,
    isSymbian,
    isAndroid,
    isFireFox,
    isChrome,
    isTablet,
    isIphoneXSeries
  }
}

export const deviceInfo = checkDevice()

export default null
